var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationSuccess = function SvgNotificationSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#39B05B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.444 7.253v.662c-.001 2.893-1.882 5.44-4.619 6.258-2.734.818-5.675-.281-7.23-2.705a6.6 6.6 0 0 1 .509-7.802 6.39 6.39 0 0 1 7.516-1.72.667.667 0 0 0 .548-1.215 7.72 7.72 0 0 0-9.083 2.075 7.93 7.93 0 0 0-.612 9.382c1.874 2.923 5.429 4.251 8.734 3.262 3.304-.988 5.569-4.054 5.57-7.534v-.663a.667.667 0 0 0-1.333 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 6.734a.667.667 0 0 0-.948.938L7.526 9.83a.667.667 0 0 0 .948 0l7.112-7.203a.667.667 0 1 0-.95-.937L8 8.413z"
  }))));
};
export default SvgNotificationSuccess;